import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from 'react-query'
import { Provider } from 'react-redux'
import { persistStore } from 'redux-persist'
import { PersistGate } from 'redux-persist/integration/react'

import App from '@/app'
import { Toaster } from '@/components/ui/sonner'
import store from '@/store'

const persistor = persistStore(store)
const queryClient = new QueryClient()

const container = document.getElementById('root')
if (container) {
	const root = createRoot(container)
	root.render(
		<StrictMode>
			<Provider store={store}>
				<PersistGate persistor={persistor}>
					<QueryClientProvider client={queryClient}>
						<Toaster position="top-right" closeButton richColors />
						<App />
					</QueryClientProvider>
				</PersistGate>
			</Provider>
		</StrictMode>,
	)
}
